<template>
  <div>
    <!-- BIENVENIDA SUPERPUESTA -->
    <div v-if="showWelcome" class="bienvenida-overlay">
      <div class="bienvenida-card">
        <p class="titulo-bienvenida">Bienvenidos a la invitación de<br> Ivan y Alejandra </p>
        <button @click="ocultarBienvenida">Ingresar</button>
      </div>
    </div>

    <!-- SECCIÓN PRINCIPAL -->
    <transition name="fade">
      <div
        v-if="isVisible"
        class="fotoportada-container"
        ref="portadaRef"
      >
        <!-- Imagen PNG con áreas transparentes -->
        <img 
          src="@/assets/portada-11.webp" 
          alt="Imagen de portada" 
          class="fotoportada-img invisible" 
          ref="imagenPortada"
        >
        <!-- Overlay con texto -->
        <div class="overlay">
          <div class="contenido-texto" ref="contenidoTextoRef">
            <br><br><br><br>
            <div class="centered-text" ref="textRef">
              <p class="titulo-boda">NUESTRA BODA</p>
              <h1 class="nombres">
                ALEJANDRA <br>
                <img src="@/assets/and.png" alt="separador" class="ampersand-img" ref="ampersandRef" /><br>
                IVAN
              </h1>
              <p class="fecha">
                11 / JUL / 2025
                <i class="fas fa-heart icono-blanco"></i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'NavbarComponent',
  setup() {
    const isVisible = ref(true);
    const showWelcome = ref(true);
    const textRef = ref(null);
    const contenidoTextoRef = ref(null);
    const portadaRef = ref(null);
    const imagenPortada = ref(null);
    const ampersandRef = ref(null);

    const ocultarBienvenida = () => {
      showWelcome.value = false;

      nextTick(() => {
        imagenPortada.value.classList.remove('invisible');

        // Animación general (una sola) que incluye todo el texto y ampersand
        const tl = gsap.timeline();

        // Fade-in imagen
        tl.fromTo(
          imagenPortada.value,
          { opacity: 0 },
          {
            opacity: 1,
            duration: 0.8,
            ease: 'power2.out'
          }
        );

        // Texto completo con ampersand incluido
        tl.from(textRef.value.querySelector('.titulo-boda'), {
          y: 20,
          opacity: 0,
          duration: 0.5,
          ease: 'power2.out'
        }, '-=0.2')
        .from(textRef.value.querySelector('.nombres'), {
          y: 25,
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out'
        }, '-=0.4')
     .from(ampersandRef.value, {
  scale: 0.5, // Comienza más pequeño para un efecto más dramático
  opacity: 0,
  rotation: -15, // Un poco más de rotación inicial
  duration: 1.2, // Duración más larga para transición más suave
  ease: "back.out(2.5)", // Curva de easing más suave
  transformOrigin: "center center", // Asegura que la rotación sea desde el centro
  y: 20, // Pequeño desplazamiento vertical inicial
}, '-=0.4')
        .from(textRef.value.querySelector('.fecha'), {
          y: 15,
          opacity: 0,
          duration: 0.5,
          ease: 'power2.out'
        }, '-=0.4');
      });
    };

    onMounted(() => {
      gsap.set(".bienvenida-card", { opacity: 0, y: 20 });
      gsap.to(".bienvenida-card", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        delay: 0.3,
        ease: "power2.out"
      });
    });

    return {
      isVisible,
      textRef,
      contenidoTextoRef,
      portadaRef,
      imagenPortada,
      ampersandRef,
      showWelcome,
      ocultarBienvenida
    };
  },
};
</script>

<style>
.invisible {
  visibility: hidden;
}
</style>

<style scoped>
.bienvenida-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bienvenida-card {
  text-align: center;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.titulo-bienvenida {
  font-size: 14px;
  margin-bottom: 30px;
  font-family: 'Playfair Display', serif;
  color: #333;
}

.bienvenida-card button {
  background-color: #bdbdbd;
  color: white;
  font-size: 12px;
  border: none;
  padding: 8px 20px;
  border-radius: 30px;
  cursor: pointer;
  transition: background 0.3s;
}

.bienvenida-card button:hover {
  background-color: #9e9e9e;
}

.fadeInUp {
  animation: fadeInUp 0.1s ease forwards;
}
/* Barra de navegación */
body {
  margin: 0;
  padding: 0;
}

/* Texto animado */
.animated-text {
  flex-grow: 1;
  text-align: center;
}



.animated-text p {
  font-family: 'Dancing Script', cursive;
  font-size: 24px;
  color: #4a3f3fef;
  animation: scaleText 1s infinite alternate;
}

@keyframes scaleText {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.5);
  }
}





.fotoportada-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  margin-top: -58px;
}

.fotoportada-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  will-change: transform, opacity, filter;
}

  /* Animación de acercamiento */
@keyframes popupFadeIn {
  0% {
    opacity: 0;
    transform: scale(0.8); /* Comienza más pequeño */
  }
  100% {
    opacity: 1;
    transform: scale(1); /* Termina en su tamaño original */
  }
}
.overlay {
  position: absolute; /* Cambiado a absolute para cubrir toda la imagen */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* Centra el contenido en el medio */
  color: white;
  z-index: 2;
  padding-top:180px; /* Añade padding superior */
}


.fotoPortada {
  width: 100%;
  height: 100%;
}

@font-face {
  font-family: 'Daydream';
  src: url('../assets/fonts/daydream.ttf') format('truetype');  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Karla';
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/karla/v31/qkBIXvYC6trAT55ZBi1ueQVIjQTDeJqaE0lK.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
.centered-text {
  position: absolute;
  font-size: 38px; /* Asegúrate de que este tamaño sea adecuado para pantallas grandes */
  font-weight: 400;
  text-align: center;
  margin-top: -30px;
  margin-bottom: 0px;
  font-family: 'FeelingPassionate', sans-serif; /* Asegúrate de que la fuente esté cargada */
  background: rgb(253, 253, 253);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent; /* Hacer el texto transparente para aplicar el fondo */
  line-height: 1.6; /* Ajusta la altura de la línea para evitar que las letras se corten */
  white-space: nowrap; /* Evita que el texto se divida en varias líneas */
  animation: fadeInUp 1s ease forwards, animateText 3s linear infinite; /* Añadimos ambas animaciones */
  opacity: 0; /* Inicialmente invisible */
  transform: translateY(80px); /* Iniciar desplazamiento desde abajo */
  animation-delay: 1.3s; /* Retraso para asegurar que la animación comience con un pequeño retraso */

}


@keyframes animateText {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: 0 0;
  }
}


.text {
  font-size: 18px;
  text-align: center;
  color: rgba(255, 255, 255, 0.95);
  margin: 0 10px; /* Ajusta el espaciado entre la línea y el texto */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  font-family: 'Karla'; /* Cambia la familia de fuentes según tu necesidad */
  opacity: 0; /* Para que empiece invisible */
  transform: translateY(80px);
  animation: fadeInUp 1s ease forwards; /* Controla la duración y suavidad */
  animation-delay: 0.5s; /* Retraso de 0.2 segundos para asegurar visibilidad */
}

.line {
  content: " ";
  display: block;
  width: 40px; /* Ajusta el largo de la línea */
  height: 2px; /* Grosor de la línea */
  background-color: #ebe5e5a1; /* Color de la línea */
   /* Añadir la animación aquí */
   opacity: 0; /* Para que empiece invisible */
  transform: translateY(80px);
  animation: fadeInUp 1s ease forwards; /* Controla la duración y suavidad */
  animation-delay: 0.5s; /* Retraso de 0.2 segundos para asegurar visibilidad */

}

.centered-fechatext {
  font-size: 10px;
  font-weight: 300;
  text-align: center;
  letter-spacing: 2px;
  color: rgba(237, 230, 230, 0.934); /* Color del texto */
  margin-top: -10; /* Asegúrate de que no haya margen superior */
  font-family: 'karla';
  letter-spacing: 2px;
  /* Estilos de fondo */
  padding-left: 0;
  padding-right: 0;
  background-color: rgba(83, 72, 72, 0.5); /* Fondo semitransparente */
  border-radius: 8px; /* Bordes redondeados */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3); /* Sombra para profundidad */
  max-width: 80%; /* Ancho máximo para que no ocupe toda la pantalla */
}






  .animated-text p {
    font-size: 20px; /* Reduce el tamaño del texto en pantallas pequeñas */
  padding-left: 0;
  padding-right: 0;

  margin: 0;

  display: flex;

}
.animated-text {
  display: flex; /* Asegúrate de que el contenedor tenga display: flex */
  justify-content: center; /* Centra el contenido horizontalmente */
  align-items: center; /* Centra el contenido verticalmente */
  text-align: center; /* Asegúrate de que el texto esté centrado */
}



.animate__fadeInUp {
  animation: fadeInUp 0.5s forwards; /* Cambia la duración como necesites */
}

@keyframes fadeInUp {
  from {
    transform: translateY(20px); /* Comienza 20px más abajo */
    opacity: 0; /* Comienza oculto */
  }
  to {
    transform: translateY(0); /* Vuelve a su posición original */
    opacity: 1; /* Se hace visible */
  }
}

.fade-leave-active {
  opacity: 0; /* Se desvanecerá */
  transition: opacity 0.3s ease;
}




/* Animación de entrada desde abajo */
.fade-in-up {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 2s ease forwards; /* Duración y suavizado */
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px); /* Empieza desplazado 20px hacia abajo */
  }
  100% {
    opacity: 1;
    transform: translateY(0); /* Llega a la posición final */
  }
}
.superposed-image {
  position: absolute; /* Mantiene la imagen posicionada absolutamente dentro del contenedor */
  top: 75%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  z-index: 5;
  
}

.textfaltan2 {
  font-family: 'Dancing Script', cursive;
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 10px;
  margin-top: 10px;
  background: linear-gradient(270deg, #2e2e2c,#96a499, #a49996);
  background-size: 200% 100%;
  background-position: 0 0;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: gradientAnimation 5s ease infinite; /* Animación */
}
.textfecha1 {
  font-size: 24px;
  font-weight: 100;
  font-family: 'Karla';
  color: #FFFFFF; /* Blanco */
  margin-top: 30px;
}
/* Ornamentos */
.contenido-texto {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: white;
  animation: fadeInUp 1.5s ease forwards;
  opacity: 0;
  transform: translateY(60px);
}
/* Ornamentos */
.ornamento {
  width: 180px;
  height: auto;
  opacity: 0.9;
}
.nombres {
  text-align: center;
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  line-height: 1.2;
  margin: 20px 0;
}

.ampersand-img {
  width: 240px; /* Ajusta según el diseño */
  height: auto;
  opacity: 0.9;
  margin: 8px 0;
}

.ornamento-top {
  margin-bottom: 8px;
}

.ornamento-bottom {
  margin-top: 10px;
}
.textfaltan {
  font-size: 24px;
  font-weight: 100;
  font-family: 'Karla';

  margin-top: 30px;
  background: linear-gradient(270deg, #313131, #181817, #20201f);
  background-size: 200% 100%;
  background-position: 0 0;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: gradientAnimation 5s ease infinite; /* Animación */
}

.icono-blanco {
  color: #FFFFFF;
  font-size: 24px; /* Tamaño del ícono */
  margin-top: -60px; /* Espaciado */
}

.titulo-boda {
  font-family: 'Karla', sans-serif;
  letter-spacing: 4px;
  color: #ffffff;
  font-size: 13px;
  margin-bottom: 12px;
}
.nombres {
 font-family: 'nombres';
  font-weight: 400;  font-size: 34px;
  color: #fff;
    letter-spacing: 1px;

  margin: 0;
  line-height: 1.2;
}

.fecha {
  font-family: 'Karla', sans-serif;
  font-size: 16px;
  letter-spacing: 3px;
  color: #fff;
  margin-top: 10px;
}
.icono-blanco {
  color: #fff;
  font-size: 14px;
  margin-left: 5px;
}

@keyframes gradientAnimation {
  0% {
    background-position: 200% 0; /* Inicia desde la derecha */
  }
  100% {
    background-position: 0 0; /* Termina a la izquierda */
  }}
  .animate-slideInLeft {
  animation: slideInLeft 1s ease-out;
}



.separador-img {
  width: 100%;
  max-width: 50%; /* Cambia esto para hacerla más pequeña */
  height: auto;
  display: block;
  margin-top: 20px;
}

</style>